import React from 'react';
import classNames from 'classnames';
import styles from './styles.module.scss';
import Spinner from '../Spinner';

const ThetanButton = ({
  className,
  title,
  onClick,
  type = 'primary',
  disabled,
  loading
}) => /*#__PURE__*/React.createElement("button", {
  disabled: disabled || loading,
  onClick: onClick,
  className: classNames(styles.container, type === 'secondary' && styles.secondary, className)
}, !loading ? /*#__PURE__*/React.createElement("span", null, title) : /*#__PURE__*/React.createElement(Spinner, {
  secondary: true,
  size: 40
}));

export default ThetanButton;